/**
 * Permanent fix for "ResizeObserver loop completed with undelivered notifications".
 *
 * Root cause: Ant Design Select uses ResizeObserver. When cascading dropdowns update
 * (e.g. Location → Floor), multiple layout changes in the same frame cause
 * ResizeObserver to break the loop and throw this error. CRA's dev overlay catches
 * it via addEventListener('error') and shows a full-screen crash.
 *
 * Fix 1: Wrap all ResizeObserver callbacks in requestAnimationFrame so resize→callback
 *         chains never run synchronously in the same frame.
 * Fix 2: Suppress the error at the window event level so CRA's overlay ignores it.
 *
 * This file MUST be imported before any other import in index.js.
 */

// 1. Patch ResizeObserver to defer callbacks
const OriginalResizeObserver = window.ResizeObserver;
window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
  constructor(callback) {
    super((entries, observer) => {
      window.requestAnimationFrame(() => {
        if (observer.__connected !== false) {
          callback(entries, observer);
        }
      });
    });
    this.__connected = true;
  }

  disconnect() {
    this.__connected = false;
    super.disconnect();
  }
};

// 2. Suppress the error event so CRA's error overlay doesn't show it
window.addEventListener("error", (e) => {
  if (
    e.message &&
    e.message.includes("ResizeObserver loop")
  ) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
  }
});
